import { Component, OnInit } from '@angular/core';
import { AlertState } from '../../services/alert-wrapper.service';
import { Observable } from 'rxjs';
import { warningService } from '../../services/warning.service';

@Component({
  selector: 'app-warning-alert-wrapper',
  templateUrl: './warning-alert-wrapper.component.html',
  styleUrls: ['./warning-alert-wrapper.component.scss']
})
export class WarningAlertWrapperComponent {
  constructor(private warning: warningService) { }
  isOpen: Observable<AlertState> | null = null;

  ngOnInit(): void {
    this.isOpen = this.warning.isOpen;

  }
  onClose() {
    this.warning?.close();
  }
}
